import { ContractDefinition } from "./ContractDefinition";
import { GridPagination } from "./GridPagination";

export class ContractDefinitionActionEmitter {
  action: string;
  definition: ContractDefinition;
  pagination: GridPagination;
}
